import * as tslib_1 from "tslib";
import { HtmlModel } from '@swim/ui';
var MapModel = (function (_super) {
    tslib_1.__extends(MapModel, _super);
    function MapModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MapModel;
}(HtmlModel));
export { MapModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwLW1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWFwLW1vZGVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsU0FBUyxFQUFDLE1BQU0sVUFBVSxDQUFDO0FBRW5DO0lBQThCLG9DQUFTO0lBQXZDOztJQUVBLENBQUM7SUFBRCxlQUFDO0FBQUQsQ0FBQyxBQUZELENBQThCLFNBQVMsR0FFdEMifQ==